'use client'
import { Icon, type IconProps } from '@iconify/react'

const IconifyIcon = (props: IconProps) => {
  return <Icon {...props} />
}

export default IconifyIcon
